const de = {
  // Common
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.create": "Erstellen",
  "common.search": "Suchen",
  "common.filter": "Filter",
  "common.reset": "Zurücksetzen",
  "common.close": "Schließen",
  "common.confirm": "Bestätigen",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.loading": "Wird geladen...",
  "common.saved": "Gespeichert!",
  "common.error": "Fehler",
  "common.success": "Erfolgreich",
  "common.preview": "Vorschau",
  "common.actions": "Aktionen",
  "common.status": "Status",
  "common.active": "Aktiv",
  "common.inactive": "Inaktiv",
  "common.all": "Alle",
  "common.none": "Keine",
  "common.total": "Gesamt",
  "common.back": "Zurück",
  "common.next": "Weiter",
  "common.refresh": "Aktualisieren",
  "common.add": "Hinzufügen",
  "common.remove": "Entfernen",
  "common.upload": "Hochladen",
  "common.download": "Herunterladen",
  "common.copy": "Kopieren",
  "common.publish": "Veröffentlichen",
  "common.archive": "Archivieren",
  "common.draft": "Entwurf",
  "common.name": "Name",
  "common.description": "Beschreibung",
  "common.date": "Datum",
  "common.views": "Aufrufe",
  "common.author": "Autor",
  "common.category": "Kategorie",
  "common.image": "Bild",
  "common.title": "Titel",
  "common.slug": "Slug",
  "common.email": "E-Mail",
  "common.password": "Passwort",
  "common.role": "Rolle",
  "common.website": "Website",
  "common.mockData": "Mock-Daten",
  "common.liveData": "Live-Daten",
  "common.demoMode": "Demo-Modus",
  "common.noResults": "Keine Ergebnisse gefunden.",
  "common.irreversible": "Diese Aktion kann nicht rückgängig gemacht werden.",

  // Navigation
  "nav.dashboard": "Dashboard",
  "nav.content": "Inhalt",
  "nav.articles": "Artikel",
  "nav.categories": "Kategorien",
  "nav.authors": "Autoren",
  "nav.media": "Mediathek",
  "nav.website": "Website",
  "nav.ads": "Werbung",
  "nav.homepage": "Startseite",
  "nav.breaking": "Breaking News",
  "nav.seo": "SEO",
  "nav.newsletter": "Newsletter",
  "nav.pages": "Seiten",
  "nav.system": "System",
  "nav.settings": "Einstellungen",
  "nav.users": "Benutzer & Rollen",
  "nav.analytics": "Analytik",
  "nav.brand": "Marke",
  "nav.closeMenu": "Menü schließen",
  "nav.openMenu": "Menü öffnen",
  "nav.adminPanel": "Admin Panel",
  "nav.viewWebsite": "Website",
  "nav.loggedInAs": "Angemeldet als",
  "nav.logout": "Abmelden",

  // Login
  "login.title": "Admin Login",
  "login.subtitle": "Melden Sie sich an, um die Website zu verwalten.",
  "login.email": "E-Mail",
  "login.password": "Passwort",
  "login.submit": "Anmelden",
  "login.submitting": "Anmelden...",
  "login.demoAccounts": "Demo-Zugangsdaten:",
  "login.error.invalid": "Ungültige E-Mail oder Passwort. Bitte überprüfen Sie Ihre Zugangsdaten.",
  "login.error.unauthorized": "Ihr Konto hat keine Admin-Berechtigung. Bitte wenden Sie sich an den Administrator.",
  "login.error.noProfile": "Ihr Konto wurde gefunden, aber es existiert noch kein Profil. Ein Profil wurde automatisch erstellt. Bitte wenden Sie sich an den Administrator, um Ihre Rolle zu setzen.",
  "login.error.supabase": "Verbindungsfehler mit der Datenbank",
  "login.error.unknown": "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  "login.helpText": "Melden Sie sich mit Ihrer Supabase-E-Mail und Ihrem Passwort an. Ihr Konto muss in der Tabelle \"profiles\" die Rolle \"admin\" oder \"super_admin\" haben.",
  "login.forgotPassword": "Passwort vergessen?",

  // Forgot password
  "forgotPassword.title": "Passwort zurücksetzen",
  "forgotPassword.subtitle": "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
  "forgotPassword.email": "E-Mail-Adresse",
  "forgotPassword.submit": "Link senden",
  "forgotPassword.submitting": "Wird gesendet...",
  "forgotPassword.backToLogin": "Zurück zum Login",
  "forgotPassword.success.title": "E-Mail gesendet!",
  "forgotPassword.success.message": "Falls ein Konto mit dieser E-Mail existiert, erhalten Sie in Kürze einen Link zum Zurücksetzen des Passworts. Bitte prüfen Sie auch Ihren Spam-Ordner.",
  "forgotPassword.error.generic": "Fehler beim Senden der E-Mail. Bitte versuchen Sie es erneut.",

  // Reset password
  "resetPassword.title": "Neues Passwort setzen",
  "resetPassword.subtitle": "Geben Sie Ihr neues Passwort ein.",
  "resetPassword.newPassword": "Neues Passwort",
  "resetPassword.confirmPassword": "Passwort bestätigen",
  "resetPassword.submit": "Passwort speichern",
  "resetPassword.submitting": "Wird gespeichert...",
  "resetPassword.success.title": "Passwort geändert!",
  "resetPassword.success.message": "Ihr Passwort wurde erfolgreich geändert. Sie werden zum Login weitergeleitet.",
  "resetPassword.error.mismatch": "Die Passwörter stimmen nicht überein.",
  "resetPassword.error.tooShort": "Das Passwort muss mindestens 8 Zeichen lang sein.",
  "resetPassword.error.generic": "Fehler beim Ändern des Passworts. Bitte versuchen Sie es erneut.",
  "resetPassword.error.invalidLink": "Dieser Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.",

  // Dashboard
  "dashboard.title": "Dashboard",
  "dashboard.overview": "Übersicht",
  "dashboard.quickActions": "Schnellaktionen",
  "dashboard.mostRead": "Meistgelesen",
  "dashboard.latestArticles": "Neueste Artikel",
  "dashboard.allArticles": "Alle Artikel anzeigen",
  "dashboard.adSenseReady": "AdSense Bereit",
  "dashboard.breaking": "Breaking",
  "dashboard.stats.articles": "Artikel",
  "dashboard.stats.published": "veröffentlicht",
  "dashboard.stats.drafts": "Entwürfe",
  "dashboard.stats.scheduled": "geplant",
  "dashboard.stats.categories": "Kategorien",
  "dashboard.stats.authors": "Autoren",
  "dashboard.stats.columnists": "Kolumnisten",
  "dashboard.stats.views": "Aufrufe",
  "dashboard.stats.ads": "Werbung",
  "dashboard.stats.slots": "Slots",
  "dashboard.stats.newsletter": "Newsletter",
  "dashboard.stats.subscribers": "Abonnenten",
  "dashboard.stats.regular": "Regulär",
  "dashboard.quickAction.newArticle": "Neuer Artikel",
  "dashboard.quickAction.breaking": "Breaking",
  "dashboard.quickAction.media": "Bilder",
  "dashboard.quickAction.seo": "SEO",
  "dashboard.quickAction.newsletter": "Newsletter",
  "dashboard.quickAction.analytics": "Analytik",
  "dashboard.article.views": "Aufrufe",
  "dashboard.article.edit": "Bearbeiten",

  // Articles
  "articles.title": "Artikel",
  "articles.total": "Artikel insgesamt",
  "articles.new": "Neuer Artikel",
  "articles.search": "Artikel suchen...",
  "articles.allCategories": "Alle Kategorien",
  "articles.allStatus": "Alle Status",
  "articles.allAuthors": "Alle Autoren",
  "articles.selected": "ausgewählt",
  "articles.bulkPublish": "Veröffentlichen",
  "articles.bulkArchive": "Archivieren",
  "articles.bulkDelete": "Löschen",
  "articles.deleteTitle": "Artikel löschen?",
  "articles.deleteConfirm": "Diese Aktion kann nicht rückgängig gemacht werden. Der Artikel wird dauerhaft entfernt.",
  "articles.deleted": "Artikel wurde gelöscht.",
  "articles.deleteError": "Fehler beim Löschen.",
  "articles.published": "Artikel veröffentlicht.",
  "articles.publishError": "Fehler beim Veröffentlichen.",
  "articles.archived": "Artikel archiviert.",
  "articles.archiveError": "Fehler beim Archivieren.",
  "articles.status.draft": "Entwurf",
  "articles.status.pending_review": "Prüfung",
  "articles.status.published": "Veröffentlicht",
  "articles.status.scheduled": "Geplant",
  "articles.status.archived": "Archiviert",
  "articles.col.article": "Artikel",
  "articles.col.category": "Kategorie",
  "articles.col.author": "Autor",
  "articles.col.status": "Status",
  "articles.col.date": "Datum",
  "articles.col.views": "Aufrufe",
  "articles.col.flags": "Flags",
  "articles.col.actions": "Aktionen",
  "articles.noFound": "Keine Artikel gefunden.",
  "articles.loading": "Artikel werden geladen...",

  // Categories
  "categories.title": "Kategorien",
  "categories.total": "Kategorien insgesamt",
  "categories.new": "Neue Kategorie",
  "categories.search": "Kategorien suchen...",
  "categories.stats.total": "Gesamt",
  "categories.stats.active": "Aktiv",
  "categories.stats.inMenu": "Im Menü",
  "categories.stats.homepage": "Homepage",
  "categories.createTitle": "Neue Kategorie erstellen",
  "categories.editTitle": "bearbeiten",
  "categories.deleteTitle": "Kategorie löschen?",
  "categories.deleteConfirm": "Diese Aktion kann nicht rückgängig gemacht werden. Alle Artikel in dieser Kategorie müssen neu zugewiesen werden.",
  "categories.tab.general": "Allgemein",
  "categories.tab.seo": "SEO",
  "categories.tab.display": "Anzeige",
  "categories.tab.subcategories": "Unterkategorien",
  "categories.col.order": "Reihenf.",
  "categories.col.category": "Kategorie",
  "categories.col.slug": "Slug",
  "categories.col.subcategories": "Unterkategorien",
  "categories.col.articles": "Artikel",
  "categories.col.menu": "Menü",
  "categories.col.homepage": "Homepage",
  "categories.col.status": "Status",
  "categories.col.actions": "Aktionen",
  "categories.noFound": "Keine Kategorien gefunden.",

  // Categories form
  "categories.form.name": "Name *",
  "categories.form.namePlaceholder": "Kategoriename",
  "categories.form.slug": "Slug *",
  "categories.form.slugPlaceholder": "kategorie-slug",
  "categories.form.description": "Beschreibung",
  "categories.form.descriptionPlaceholder": "Kurze Beschreibung der Kategorie...",
  "categories.form.descriptionCharCount": "Zeichen",
  "categories.form.imageUrl": "Kategoriebild (URL)",
  "categories.form.imageUrlPlaceholder": "https://...",
  "categories.form.imagePreview": "Vorschau",
  "categories.form.color": "Farbe",
  "categories.form.activeToggle": "Kategorie aktiv",
  "categories.form.activeToggleDesc": "Kategorie ist sichtbar und zugänglich",
  "categories.form.seoTitle": "SEO-Titel",
  "categories.form.seoTitlePlaceholder": "SEO-Titel für diese Kategorie...",
  "categories.form.seoTitleCharCount": "Zeichen empfohlen",
  "categories.form.seoDescription": "SEO-Beschreibung",
  "categories.form.seoDescriptionPlaceholder": "Meta-Beschreibung für Suchmaschinen...",
  "categories.form.seoDescriptionCharCount": "Zeichen empfohlen",
  "categories.form.googlePreview": "Google-Vorschau",
  "categories.form.showInMenu": "Im Hauptmenü anzeigen",
  "categories.form.showInMenuDesc": "Kategorie erscheint in der Navigation",
  "categories.form.showOnHomepage": "Auf Homepage anzeigen",
  "categories.form.showOnHomepageDesc": "Kategorie-Sektion erscheint auf der Startseite",
  "categories.form.menuOrder": "Menü-Reihenfolge",
  "categories.form.homepageOrder": "Homepage-Reihenfolge",
  "categories.form.headerPreview": "Vorschau Kategorie-Header",
  "categories.form.categoryNamePlaceholder": "Kategoriename",
  "categories.form.descriptionShortPlaceholder": "Beschreibung...",
  "categories.form.noSubcategories": "Keine Unterkategorien vorhanden",
  "categories.form.addSubcategory": "Neue Unterkategorie hinzufügen",
  "categories.form.subcategoryNamePlaceholder": "Name der Unterkategorie",
  "categories.form.subcategorySlugPlaceholder": "unterkategorie-slug",
  "categories.form.addSubcategoryButton": "Unterkategorie hinzufügen",

  // Users
  "users.title": "Benutzer & Rollen",
  "users.invite": "Einladen",
  "users.search": "Benutzer suchen...",
  "users.changeRole": "Rolle ändern",
  "users.changeRoleTitle": "Rolle ändern",
  "users.inviteTitle": "Benutzer einladen",
  "users.inviteName": "Name",
  "users.inviteEmail": "E-Mail",
  "users.inviteRole": "Rolle",
  "users.inviteSubmit": "Einladung senden",
  "users.roleChanged": "Rolle wurde aktualisiert.",
  "users.roleError": "Fehler beim Aktualisieren der Rolle.",
  "users.statusChanged": "Status wurde aktualisiert.",
  "users.statusError": "Fehler beim Aktualisieren des Status.",
  "users.inviteSent": "Einladung wurde gesendet.",
  "users.inviteError": "Fehler beim Senden der Einladung.",
  "users.col.user": "Benutzer",
  "users.col.role": "Rolle",
  "users.col.status": "Status",
  "users.col.lastLogin": "Letzter Login",
  "users.col.actions": "Aktionen",
  "users.noFound": "Keine Benutzer gefunden.",
  "users.permissionsMatrix": "Berechtigungsmatrix",

  // Brand
  "brand.title": "Markeneinstellungen",
  "brand.texts": "Texte",
  "brand.logos": "Logos",
  "brand.colors": "Farben",
  "brand.preview": "Vorschau",
  "brand.siteName": "Website-Name",
  "brand.slogan": "Slogan",
  "brand.logoStandard": "Logo (Standard)",
  "brand.logoDark": "Logo (Dunkel)",
  "brand.favicon": "Favicon",
  "brand.primaryColor": "Primärfarbe (Text, Header)",
  "brand.accentColor": "Akzentfarbe (Logo, Links, Buttons)",
  "brand.saved": "Gespeichert",
  "brand.reset": "Zurücksetzen",

  // Article Editor
  "articleForm.newArticle": "Neuer Artikel",
  "articleForm.editArticle": "Artikel bearbeiten",
  "articleForm.duplicate": "Duplizieren",
  "articleForm.preview": "Vorschau",
  "articleForm.delete": "Löschen",
  "articleForm.cancel": "Abbrechen",
  "articleForm.saveDraft": "Als Entwurf speichern",
  "articleForm.publish": "Veröffentlichen",
  "articleForm.saving": "Speichern...",
  "articleForm.publishing": "Veröffentlichen...",
  "articleForm.saved": "Gespeichert",
  "articleForm.saveError": "Fehler beim Speichern:",
  "articleForm.tab.content": "Inhalt",
  "articleForm.tab.media": "Medien",
  "articleForm.tab.settings": "Einstellungen",
  "articleForm.tab.seo": "SEO",
  "articleForm.tab.links": "Links",
  "articleForm.title": "Titel",
  "articleForm.titlePlaceholder": "Artikeltitel eingeben...",
  "articleForm.subtitle": "Untertitel",
  "articleForm.subtitlePlaceholder": "Kurzer Untertitel...",
  "articleForm.slug": "Slug (URL)",
  "articleForm.slugPlaceholder": "artikel-slug",
  "articleForm.excerpt": "Kurzbeschreibung",
  "articleForm.excerptPlaceholder": "Kurze Zusammenfassung...",
  "articleForm.content": "Inhalt",
  "articleForm.contentPlaceholder": "Artikelinhalt eingeben... HTML-Tags werden unterstützt.",
  "articleForm.contentChars": "Zeichen | HTML wird unterstützt",
  "articleForm.featuredImage": "Hauptbild",
  "articleForm.gallery": "Bildergalerie",
  "articleForm.addImage": "Bild hinzufügen",
  "articleForm.noGallery": "Keine Bilder in der Galerie",
  "articleForm.categoryAuthor": "Kategorie & Autor",
  "articleForm.category": "Kategorie",
  "articleForm.selectCategory": "Kategorie wählen",
  "articleForm.noCategories": "Noch keine Kategorien. Bitte zuerst eine Kategorie erstellen.",
  "articleForm.createCategory": "Kategorie erstellen",
  "articleForm.subcategory": "Unterkategorie",
  "articleForm.author": "Autor",
  "articleForm.selectAuthor": "Autor wählen",
  "articleForm.noAuthors": "Noch keine Autoren. Bitte zuerst einen Autor erstellen.",
  "articleForm.createAuthor": "Autor erstellen",
  "articleForm.tags": "Tags",
  "articleForm.tagsPlaceholder": "Tag1, Tag2, Tag3",
  "articleForm.statusPublishing": "Status & Veröffentlichung",
  "articleForm.status": "Status",
  "articleForm.publishDate": "Veröffentlichungsdatum",
  "articleForm.status.draft": "Entwurf",
  "articleForm.status.pending_review": "Prüfung ausstehend",
  "articleForm.status.published": "Veröffentlicht",
  "articleForm.status.scheduled": "Geplant",
  "articleForm.status.archived": "Archiviert",
  "articleForm.specialFlags": "Sondermarkierungen",
  "articleForm.flag.featured": "Featured Artikel",
  "articleForm.flag.breaking": "Breaking News",
  "articleForm.flag.topNews": "Top News",
  "articleForm.flag.homepageSlider": "Homepage Slider",
  "articleForm.flag.topNewsColumn": "Top News Spalte",
  "articleForm.flag.categoryFeatured": "Kategorie Featured",
  "articleForm.options": "Optionen",
  "articleForm.commentsEnabled": "Kommentare aktivieren",
  "articleForm.commentsEnabledDesc": "Leser können Kommentare hinterlassen",
  "articleForm.adsEnabled": "Werbung aktivieren",
  "articleForm.adsEnabledDesc": "Anzeigen werden im Artikel angezeigt",
  "articleForm.seoTitle": "SEO-Titel",
  "articleForm.seoDescription": "Meta-Beschreibung",
  "articleForm.focusKeyword": "Fokus-Keyword",
  "articleForm.canonicalUrl": "Kanonische URL",
  "articleForm.imageAlt": "Alt-Text Hauptbild",
  "articleForm.noIndex": "Seite nicht indexieren (noindex)",
  "articleForm.noIndexDesc": "Verhindert, dass Suchmaschinen diese Seite indexieren",
  "articleForm.articleInfo": "Artikel-Info",
  "articleForm.readTime": "Lesezeit:",
  "articleForm.wordCount": "Wörter:",
  "articleForm.estimatedReadTime": "Geschätzte Lesezeit",
  "articleForm.statusSummary": "Status-Übersicht",
  "articleForm.deleteTitle": "Artikel löschen?",
  "articleForm.deleteConfirm": "Diese Aktion kann nicht rükgängig gemacht werden. Der Artikel wird dauerhaft entfernt.",
  "articleForm.previewTitle": "Artikel-Vorschau",
  "articleForm.breadcrumbArticles": "Artikel",
  "articleForm.columnistNote": "Dieser Artikel wird als Kolumne markiert",
  "articleForm.scheduledNote": "Dieser Artikel wird am geplanten Datum automatisch veröffentlicht.",
  "articleForm.sources": "Quellen & Referenzen",
  "articleForm.addSource": "Quelle hinzufügen",
  "articleForm.noSources": "Keine Quellen hinzugefügt",
  "articleForm.internalLinks": "Interne Links",
  "articleForm.addInternalLink": "Link hinzufügen",
  "articleForm.noInternalLinks": "Keine internen Links",
  "articleForm.externalLinks": "Externe Links",
  "articleForm.addExternalLink": "Link hinzufügen",
  "articleForm.noExternalLinks": "Keine externen Links",
  "articleForm.seoWarnings": "SEO-Warnungen",
  "articleForm.suggestKeywords": "Vorschläge",
  "articleForm.suggestedKeywords": "Vorgeschlagene Keywords",
  "articleForm.suggestKeywordsHint": "Basiert auf der Häufigkeit und Relevanz im Artikelinhalt.",
  "articleForm.noKeywordSuggestions": "Keine Keyword-Vorschläge gefunden. Bitte mehr Inhalt eingeben.",
  "articleForm.seoScoreTitle": "SEO Score",
  "articleForm.seoScoreDesc": "Echtzeit-Bewertung der SEO-Qualität des Artikels.",
  "articleForm.seoScoreExcellent": "Hervorragend",
  "articleForm.seoScoreGood": "Gut",
  "articleForm.seoScoreFair": "Ausreichend",
  "articleForm.seoScorePoor": "Verbesserungswürdig",
  "articleForm.seoOk": "Alle SEO-Felder sind korrekt ausgefüllt!",
  "articleForm.googlePreview": "Google-Suchergebnis Vorschau",
  "articleForm.ogSection": "Open Graph (Facebook, LinkedIn)",
  "articleForm.twitterSection": "Twitter/X Card",
  "articleForm.seoGenerate": "SEO automatisch generieren",
  "articleForm.seoGenerateDesc": "Leere SEO-Felder werden aus dem Artikelinhalt generiert. Fokus-Keyword-Vorschläge analysieren den Text auf häufige, bedeutsame Wörter.",
  "articleForm.seoConfirmTitle": "SEO-Felder generieren",
  "articleForm.seoConfirmDesc": "Folgende Felder sind leer und werden befüllt:",
  "articleForm.seoSkippedDesc": "Folgende Felder haben bereits Werte und werden nicht überschrieben:",
  "articleForm.seoOverwriteAll": "Auch vorhandene Felder überschreiben",
  "articleForm.seoField.title": "SEO-Titel",
  "articleForm.seoField.description": "Meta-Beschreibung",
  "articleForm.seoField.keyword": "Fokus-Keyword",
  "articleForm.seoField.imageAlt": "Alt-Text",
  "articleForm.seoField.slug": "Slug",
  "articleForm.seoGenerateBtn": "Generieren",
  "articleForm.seoCancelBtn": "Abbrechen",
  "articleForm.seoGenerated": "SEO-Felder wurden generiert!",
  "articleForm.seoPromptTitle": "SEO-Felder leer",
  "articleForm.seoPromptDesc": "Einige wichtige SEO-Felder sind noch leer. Möchten Sie diese vor der Veröffentlichung automatisch generieren lassen?",
  "articleForm.seoPromptGenerate": "Generieren & Veröffentlichen",
  "articleForm.seoPromptSkip": "Trotzdem veröffentlichen",
  "articleForm.loadingCategories": "Kategorien werden geladen...",
  "articleForm.loadingAuthors": "Autoren werden geladen...",
  "articleForm.categoriesError": "Kategorien konnten nicht geladen werden",
  "articleForm.authorsError": "Autoren konnten nicht geladen werden",
  "articleForm.min": "Min.",
  "articleForm.active": "Aktiv",
  "articleForm.inactive": "Inaktiv",

  // Dashboard extra
  "dashboard.stats.users": "Benutzer",
  "dashboard.stats.registered": "registriert",
  "dashboard.stats.media": "Medien",
  "dashboard.stats.files": "Dateien",
  "dashboard.noArticles": "Noch keine Artikel vorhanden.",

  // Analytics
  "analytics.title": "Analytik",
  "analytics.header.subtitle": "Google Analytics 4 Integration & Supabase Datenbank-Schema",
  "analytics.tab.setup": "GA4 Einrichten",
  "analytics.tab.embed": "Embed-Code",
  "analytics.tab.schema": "Datenbank-Schema",
  "analytics.status.active": "Google Analytics 4 ist aktiv",
  "analytics.status.trackingId": "Tracking-ID",
  "analytics.status.hint": "Besucher werden jetzt erfasst.",
  "analytics.status.remove": "Entfernen",

  // Newsletter
  "newsletter.title": "Newsletter",

  // Media
  "media.title": "Mediathek",

  // SEO
  "seo.title": "SEO",

  // Breaking
  "breaking.title": "Breaking News",

  // Ads
  "ads.title": "Werbung",

  // Pages
  "pages.title": "Seiten",

  // Homepage
  "homepage.title": "Startseite",

  // Authors
  "authors.title": "Autoren",

  // Settings
  "settings.title": "Einstellungen",

  // Analytics
  "analytics.setup.title": "Schritt-für-Schritt Einrichtung",
  "analytics.step1.title": "Google Analytics-Konto erstellen",
  "analytics.step1.desc": "Gehen Sie zu analytics.google.com und melden Sie sich mit Ihrem Google-Konto an. Klicken Sie auf \"Konto erstellen\" und folgen Sie den Anweisungen.",
  "analytics.step1.link": "analytics.google.com öffnen",
  "analytics.step2.title": "GA4-Property einrichten",
  "analytics.step2.desc": "Erstellen Sie eine neue Property für Ihre Website. Wählen Sie \"Google Analytics 4\" als Property-Typ. Geben Sie Ihren Website-Namen und die URL ein.",
  "analytics.step3.title": "Measurement ID kopieren",
  "analytics.step3.desc": "Nach der Einrichtung finden Sie Ihre Measurement ID unter: Verwaltung → Property → Datenstreams → Ihr Stream → Measurement ID. Sie sieht aus wie: G-XXXXXXXXXX",
  "analytics.step4.title": "ID hier einfügen und speichern",
  "analytics.step4.desc": "Fügen Sie Ihre Measurement ID in das Feld unten ein und klicken Sie auf \"Speichern\". Das Tracking wird sofort aktiviert.",
  "analytics.input.title": "Measurement ID eingeben",
  "analytics.input.subtitle": "Ihre GA4 Measurement ID beginnt mit",
  "analytics.input.placeholder": "G-XXXXXXXXXX",
  "analytics.input.error.empty": "Bitte geben Sie eine Measurement ID ein.",
  "analytics.input.error.invalid": "Ungültige Measurement ID. Format: G-XXXXXXXXXX",
  "analytics.input.save": "Speichern & Aktivieren",
  "analytics.input.saved": "Gespeichert!",
  "analytics.input.help": "Die ID wird lokal gespeichert und beim nächsten Seitenaufruf automatisch geladen.",
  "analytics.metric.users": "Besucher (30 Tage)",
  "analytics.metric.pageviews": "Seitenaufrufe (30 Tage)",
  "analytics.metric.sessions": "Sitzungen (30 Tage)",
  "analytics.metric.bounce": "Absprungrate",
  "analytics.metric.empty": "—",
  "analytics.embed.title": "Automatischer Embed-Code",
  "analytics.embed.active": "Aktiver Tracking-Code",
  "analytics.embed.inactive": "Speichern Sie zuerst eine Measurement ID im Tab \"GA4 Einrichten\".",
  "analytics.embed.toSetup": "Zur Einrichtung →",
  "analytics.howItWorks.title": "Wie funktioniert die Integration?",
  "analytics.howItWorks.step1": "Die Measurement ID wird in localStorage gespeichert.",
  "analytics.howItWorks.step2": "Beim App-Start liest App.tsx die ID und injiziert das GA4-Script dynamisch in den head.",
  "analytics.howItWorks.step3": "Bei jedem Seitenwechsel (React Router) wird automatisch ein page_view Event an GA4 gesendet.",
  "analytics.howItWorks.step4": "Admin-Seiten (/admin/*) werden vom Tracking ausgeschlossen.",
  "analytics.schema.title": "Supabase Datenbank-Schema",
  "analytics.schema.subtitle": "Führen Sie dieses SQL in Ihrem Supabase SQL-Editor aus, um die Datenbank für Helvetik Journal einzurichten.",
  "analytics.schema.copy": "SQL kopieren",
  "analytics.schema.copied": "Kopiert!",
  "analytics.schema.badges": ["articles Tabelle", "authors Tabelle", "Row Level Security", "RLS Policies"],
  "analytics.schema.step1": "Supabase Projekt öffnen",
  "analytics.schema.step1.desc": "Gehen Sie zu supabase.com und öffnen Sie Ihr Projekt.",
  "analytics.schema.step2": "SQL Editor öffnen",
  "analytics.schema.step2.desc": "Klicken Sie im linken Menü auf \"SQL Editor\" und dann auf \"New query\".",
  "analytics.schema.step3": "Schema einfügen und ausführen",
  "analytics.schema.step3.desc": "Kopieren Sie das SQL oben, fügen Sie es in den Editor ein und klicken Sie auf \"Run\".",
  "analytics.schema.step4": "Umgebungsvariablen setzen",
  "analytics.schema.step4.desc": "Stellen Sie sicher, dass VITE_SUPABASE_URL und VITE_SUPABASE_ANON_KEY in Ihren Readdy-Einstellungen gesetzt sind.",
  "analytics.remove.title": "GA4 Tracking entfernen?",
  "analytics.remove.description": "Das Tracking wird deaktiviert. Besucher werden nicht mehr erfasst. Sie können es jederzeit wieder aktivieren.",
  "analytics.remove.cancel": "Abbrechen",
  "analytics.remove.confirm": "Entfernen",

  // Users (additional)
  "users.header.subtitle": "Benutzer aus public.profiles",
  "users.refresh": "Aktualisieren",
  "users.assignForm.title": "Rolle zuweisen / aktualisieren",
  "users.assignForm.subtitle": "Benutzer muss zuerst in Supabase → Authentication → Users erstellt werden. Dieses Formular setzt oder aktualisiert die Rolle in public.profiles.",
  "users.assignForm.email": "E-Mail",
  "users.assignForm.emailPlaceholder": "benutzer@helvetik.ch",
  "users.assignForm.name": "Anzeigename (optional)",
  "users.assignForm.namePlaceholder": "Vollständiger Name",
  "users.assignForm.role": "Rolle",
  "users.assignForm.submit": "Rolle speichern",
  "users.assignForm.saving": "Wird gespeichert...",
  "users.assignForm.success": "Rolle erfolgreich gespeichert und Tabelle aktualisiert.",
  "users.howTo.title": "So funktioniert die Benutzerverwaltung:",
  "users.howTo.step1": "Erstellen Sie den Benutzer in Supabase → Authentication → Users → Add user.",
  "users.howTo.step2": "Geben Sie oben die E-Mail-Adresse ein, wählen Sie eine Rolle und klicken Sie \"Rolle speichern\".",
  "users.howTo.step3": "Der Benutzer erscheint sofort in der Tabelle unten.",
  "users.howTo.note": "Das Admin-Panel erstellt keine neuen Auth-Benutzer (Sicherheitsbeschränkung des Anon-Keys). Neue Benutzer müssen immer zuerst in Supabase Authentication angelegt werden.",
  "users.table.col.user": "Benutzer",
  "users.table.col.role": "Rolle",
  "users.table.col.created": "Erstellt",
  "users.table.col.lastLogin": "Letzter Login",
  "users.table.col.status": "Status",
  "users.table.col.actions": "Aktionen",
  "users.table.empty": "Keine Benutzer gefunden.",
  "users.table.noProfiles": "Keine Benutzer in public.profiles gefunden",
  "users.table.noProfilesHint": "Erstellen Sie einen Benutzer in Supabase → Authentication → Users, dann verwenden Sie das Formular oben, um die Rolle zuzuweisen.",
  "users.permissions.title": "Rollen & Berechtigungen Übersicht",
  "users.permissions.permission": "Berechtigung",
  "users.modal.editTitle": "Rolle bearbeiten",
  "users.modal.newRole": "Neue Rolle",
  "users.modal.permissionsFor": "Berechtigungen für",
  "users.modal.cancel": "Abbrechen",
  "users.modal.save": "Rolle speichern",
  "users.modal.saving": "Speichern...",
  "users.filter.allRoles": "Alle Rollen",
  "users.filter.allStatus": "Alle Status",
  "users.filter.active": "Aktiv",
  "users.filter.inactive": "Inaktiv",
  "users.status.active": "Aktiv",
  "users.status.inactive": "Inaktiv",
  "users.roleChanged": "Rolle wurde aktualisiert.",
  "users.roleError": "Fehler beim Aktualisieren der Rolle.",
  "users.statusChanged": "Status wurde aktualisiert.",
  "users.statusError": "Fehler beim Aktualisieren des Status.",

  // SEO
  "seo.header.title": "SEO-Einstellungen",
  "seo.header.subtitle": "Suchmaschinen-Optimierung & Google News Konfiguration",
  "seo.save": "Speichern",
  "seo.saved": "Gespeichert",
  "seo.score.title": "SEO-Gesundheit",
  "seo.score.subtitle": "Punkte erfüllt",
  "seo.score.label": "SEO-Score",
  "seo.tab.global": "Globale SEO",
  "seo.tab.sitemap": "Sitemap",
  "seo.tab.schema": "Schema Markup",
  "seo.tab.robots": "robots.txt",
  "seo.tab.checklist": "SEO-Checkliste",
  "seo.global.preview": "Google-Suchergebnis Vorschau",
  "seo.global.previewUrl": "Vorschau",
  "seo.sitemap.title": "XML Sitemap",
  "seo.sitemap.index": "Sitemap Index",
  "seo.sitemap.news": "Google News Sitemap",
  "seo.sitemap.active": "Aktiv",
  "seo.sitemap.urls": "URLs",
  "seo.sitemap.infoTitle": "Google News Sitemap",
  "seo.sitemap.infoDesc": "Die Google News Sitemap enthält nur Artikel der letzten 48 Stunden. Sie wird automatisch aktualisiert, wenn neue Artikel veröffentlicht werden. Stellen Sie sicher, dass Ihr Publisher-Name exakt mit dem bei Google News registrierten Namen übereinstimmt.",
  "seo.schema.title": "Schema Markup",
  "seo.schema.active": "Aktiv",
  "seo.schema.inactive": "Inaktiv",
  "seo.schema.previewOrg": "Organization Schema (Vorschau)",
  "seo.schema.previewNews": "NewsArticle Schema (Beispiel)",
  "seo.robots.title": "robots.txt",
  "seo.robots.warningTitle": "Wichtiger Hinweis",
  "seo.robots.warningDesc": "Stellen Sie sicher, dass der Admin-Bereich (/admin/) immer gesperrt ist. Änderungen an robots.txt können die Indexierung Ihrer Website erheblich beeinflussen.",
  "seo.checklist.category": "Kategorie",
  "seo.checklist.done": "Erledigt",
  "seo.checklist.pending": "Ausstehend",

  // Media
  "media.header.subtitle": "Dateien in Supabase Storage",
  "media.upload.button": "Hochladen",
  "media.dropzone.uploading": "Wird hochgeladen",
  "media.dropzone.title": "Dateien hierher ziehen oder klicken zum Hochladen",
  "media.dropzone.hint": "PNG, JPG, GIF, WebP, MP4 (max. 20 MB)",
  "media.filter.placeholder": "Medien suchen...",
  "media.filter.allTypes": "Alle Typen",
  "media.filter.images": "Bilder",
  "media.filter.videos": "Videos",
  "media.error.title": "Upload-Fehler",
  "media.grid.empty": "Keine Medien gefunden.",
  "media.grid.emptyHint": "Laden Sie Bilder hoch, um sie hier zu sehen.",
  "media.grid.copy": "URL kopieren",
  "media.grid.delete": "Löschen",

  // Pages
  "pages.header.subtitle": "Seiten insgesamt",
  "pages.newPage": "Neue Seite",
  "pages.search.placeholder": "Seiten suchen...",
  "pages.table.col.page": "Seite",
  "pages.table.col.slug": "Slug",
  "pages.table.col.metaTitle": "Meta-Titel",
  "pages.table.col.status": "Status",
  "pages.table.col.sections": "Abschnitte",
  "pages.table.col.edited": "Bearbeitet",
  "pages.table.col.actions": "Aktionen",
  "pages.status.published": "Veröffentlicht",
  "pages.status.draft": "Entwurf",
  "pages.editor.editTitle": "Seite bearbeiten",
  "pages.editor.newTitle": "Neue Seite",
  "pages.editor.titleLabel": "Titel",
  "pages.editor.slugLabel": "Slug",
  "pages.editor.metaTitle": "Meta-Titel",
  "pages.editor.metaDesc": "Meta-Beschreibung",
  "pages.editor.published": "Veröffentlicht",
  "pages.editor.draft": "Entwurf",
  "pages.editor.intro": "Einleitungstext",
  "pages.editor.sections": "Abschnitte",
  "pages.editor.sectionCount": "Abschnitte",
  "pages.editor.cancel": "Abbrechen",
  "pages.editor.save": "Speichern",
  "pages.editor.saving": "Speichern...",
  "pages.preview.title": "Live-Vorschau",
  "pages.preview.subtitle": "Änderungen sofort sichtbar",
  "pages.delete.title": "Seite löschen?",
  "pages.delete.description": "Diese Aktion kann nicht rückgängig gemacht werden. Die Seite wird dauerhaft entfernt.",
  "pages.delete.cancel": "Abbrechen",
  "pages.delete.confirm": "Löschen",

  // Breaking
  "breaking.header.subtitle": "aktive Ticker-Nachrichten",
  "breaking.search.placeholder": "Artikel suchen...",
  "breaking.filter.onlyBreaking": "Nur Breaking News",
  "breaking.table.active": "Aktive Breaking News",
  "breaking.table.all": "Alle Artikel",
  "breaking.table.empty": "Keine Artikel gefunden.",
  "breaking.table.noBreaking": "Keine aktiven Breaking News.",
  "breaking.status.live": "Live",
  "breaking.status.draft": "Entwurf",
  "breaking.toggle.enable": "Breaking News aktivieren",
  "breaking.toggle.disable": "Breaking News deaktivieren",
  "breaking.error.load": "Fehler beim Laden",
  "breaking.error.update": "Fehler beim Aktualisieren",

  // Homepage Admin
  "homepageAdmin.header.title": "Startseite",
  "homepageAdmin.header.subtitle": "Abschnitte anordnen und aktivieren",
  "homepageAdmin.save": "Speichern",
  "homepageAdmin.saving": "Wird gespeichert...",
  "homepageAdmin.saved": "Gespeichert!",
  "homepageAdmin.sections.title": "Abschnitte",
  "homepageAdmin.sections.hint": "Nutzen Sie die Pfeile zum Sortieren, dann auf Speichern klicken",
  "homepageAdmin.slider.title": "Hero Slider Artikel",
  "homepageAdmin.slider.hint": "Artikel mit aktiviertem \"Homepage Slider\" Flag erscheinen hier. Setzen Sie das Flag im Artikel-Editor.",
  "homepageAdmin.slider.empty": "Keine Slider-Artikel gefunden.",
  "homepageAdmin.slider.emptyHint": "Aktivieren Sie \"Homepage Slider\" bei einem veröffentlichten Artikel.",

  // Ads
  "ads.header.subtitle": "Google AdSense & Werbeplatzierungen verwalten",
  "ads.newPlacement": "Neue Platzierung",
  "ads.stats.total": "Gesamt",
  "ads.stats.active": "Aktiv",
  "ads.stats.adsense": "AdSense",
  "ads.stats.impressions": "Impressions",
  "ads.stats.clicks": "Klicks",
  "ads.stats.ctr": "CTR",
  "ads.adsense.title": "Google AdSense – Publisher-ID",
  "ads.adsense.subtitle": "Globale Publisher-ID für alle AdSense-Platzierungen",
  "ads.adsense.edit": "Bearbeiten",
  "ads.adsense.save": "Speichern",
  "ads.filter.search": "Platzierungen suchen...",
  "ads.filter.allTypes": "Alle Typen",
  "ads.filter.allDevices": "Alle Geräte",
  "ads.filter.allPages": "Alle Seiten",
  "ads.filter.allStatus": "Alle Status",
  "ads.table.col.name": "Name",
  "ads.table.col.position": "Position",
  "ads.table.col.type": "Typ",
  "ads.table.col.device": "Gerät",
  "ads.table.col.page": "Seite",
  "ads.table.col.size": "Grösse",
  "ads.table.col.impressions": "Impressions",
  "ads.table.col.ctr": "CTR",
  "ads.table.col.status": "Status",
  "ads.table.col.actions": "Aktionen",
  "ads.table.empty": "Keine Platzierungen gefunden.",
  "ads.placementMap.title": "Platzierungsübersicht",
  "ads.placementMap.desktop": "Desktop",
  "ads.placementMap.mobile": "Mobile",
  "ads.modal.edit": "Werbeplatzierung bearbeiten",
  "ads.modal.new": "Neue Werbeplatzierung",
  "ads.modal.cancel": "Abbrechen",
  "ads.modal.save": "Speichern",
  "ads.delete.title": "Platzierung löschen?",
  "ads.delete.description": "wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
  "ads.delete.cancel": "Abbrechen",
  "ads.delete.confirm": "Löschen",

  // Authors (mixed language fixes)
  "authors.header.subtitle": "Alle Autorentypen an einem Ort verwalten",
  "authors.newAuthor": "Neuer Autor",
  "authors.search.placeholder": "Autor suchen...",
  "authors.type.all": "Alle",
  "authors.type.redaktion": "Redaktion",
  "authors.type.autor": "Autoren",
  "authors.type.kolumnist": "Kolumnisten",
  "authors.type.gastautor": "Gastautoren",
  "authors.type.editor": "Editoren",
  "authors.filter.allStatus": "Alle Status",
  "authors.filter.status.active": "Aktiv",
  "authors.filter.status.inactive": "Inaktiv",
  "authors.card.latestArticle": "Letzter Artikel",
  "authors.card.articles": "Artikel",
  "authors.card.view": "Ansehen",
  "authors.card.edit": "Bearbeiten",
  "authors.card.delete": "Löschen",
  "authors.empty.title": "Noch keine Autoren vorhanden.",
  "authors.empty.noDb": "Keine Autoren in der Datenbank.",
  "authors.empty.noFilter": "Keine Autoren für die gewählten Filter gefunden.",
  "authors.modal.edit": "Autor bearbeiten",
  "authors.modal.new": "Neuer Autor",
  "authors.modal.general": "Allgemein",
  "authors.modal.bio": "Biografie",
  "authors.modal.social": "Soziale Medien",
  "authors.modal.avatar": "Profilbild",
  "authors.modal.upload": "Bild hochladen",
  "authors.modal.uploading": "Wird hochgeladen...",
  "authors.modal.uploadHint": "JPG, PNG, WEBP. Max 5 MB.",
  "authors.modal.name": "Name",
  "authors.modal.slug": "Slug",
  "authors.modal.role": "Rolle",
  "authors.modal.rolePlaceholder": "Redakteur",
  "authors.modal.email": "E-Mail",
  "authors.modal.type": "Typ",
  "authors.modal.shortBio": "Kurzbiografie",
  "authors.modal.longBio": "Langbiografie",
  "authors.modal.charCount": "Zeichen",
  "authors.modal.addSocial": "Link hinzufügen",
  "authors.modal.noSocial": "Noch keine sozialen Medien-Links hinzugefügt.",
  "authors.modal.cancel": "Abbrechen",
  "authors.modal.save": "Speichern",
  "authors.modal.create": "Erstellen",
  "authors.delete.title": "Autor löschen",
  "authors.delete.description": "Möchten Sie den Autor wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "authors.delete.articlesWarning": "Dieser Autor hat Artikel. Diese müssen neu zugewiesen werden.",
  "authors.delete.cancel": "Abbrechen",
  "authors.delete.confirm": "Löschen",

  // Footer
  "footer.developedBy": "Entwickelt von",
  "footer.allRightsReserved": "Alle Rechte vorbehalten.",
  "footer.adminPanel": "Admin Panel",
};

export default de;
